import { fetchApiGraphQL } from "@/utils/fetcher";
import { createEnrichmentIsland } from "@/utils/islands";
import { clearSession } from "@sitecorecomponents/Users/Store/tokenstore";
import { getUserAsync } from "@sitecorecomponents/Users/Store/userstore";
import { showFormMessage } from "../formMessages";

const deleteUserProfileMutation = `
  mutation DeleteUserProfile {
    deleteUserProfile
  }
`;

type DeleteUserProfileResult = {
  data: {
    deleteUserProfile: boolean | null;
  };
};

async function deleteProfile(): Promise<boolean> {
  try {
    const result = await fetchApiGraphQL<DeleteUserProfileResult>(deleteUserProfileMutation, {});
    return result?.data?.deleteUserProfile === true;
  } catch {
    return false;
  }
}

function setupConfirmDialog(form: HTMLFormElement, content: HTMLElement) {
  const emailInput = content.querySelector<HTMLInputElement>('[data-confirm-email]')!;
  const confirmButton = content.querySelector<HTMLButtonElement>('[data-confirm-button]')!;
  let email = '';
  let deleting = false;

  const dialog = document.createElement('dialog');
  dialog.append(content);
  content.hidden = false;
  dialog.onclose = () => dialog.remove();
  dialog.oncancel = (e) => deleting && e.preventDefault();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    email = (await getUserAsync())?.email ?? '';
    content.querySelector<HTMLElement>('[data-user-email]')!.textContent = email;
    emailInput.value = '';
    confirmButton.disabled = true;
    showFormMessage(dialog, null);
    document.body.append(dialog);
    dialog.showModal();
  });

  emailInput.addEventListener('input', () => {
    const emailMatches = emailInput.value.trim().toLowerCase() === email.toLowerCase();
    confirmButton.disabled = !email || !emailMatches;
  });

  emailInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !confirmButton.disabled) {
      confirmButton.click();
    }
  });

  dialog.addEventListener('click', (e) => {
    if (deleting) {
      return;
    }

    const target = e.target as HTMLElement;
    if (target === dialog || target.closest('.modal-close, [data-cancel-button]')) {
      dialog.close();
    }
  });

  confirmButton.addEventListener('click', async () => {
    confirmButton.disabled = true;
    showFormMessage(dialog, null);

    deleting = true;
    const deleted = await deleteProfile();
    deleting = false;

    if (!deleted) {
      showFormMessage(dialog, 'failed');
      confirmButton.disabled = false;
      return;
    }

    clearSession();
    content.querySelectorAll<HTMLElement>('[data-state]').forEach(el => el.hidden = el.dataset.state !== 'success');
    setTimeout(() => window.location.href = '/', 3000);
  });
}

export default function init() {
  createEnrichmentIsland('.delete-profile-form', (elm) => {
    const form = elm as HTMLFormElement;
    const content = form.querySelector<HTMLElement>('[data-confirm-delete]')!;

    setupConfirmDialog(form, content);
  });
}
